import { api } from '@/lib/api';
import type { PulseBoard, PulseConfiguration, PulsePeriod } from './types';
export const getPulse = (period: PulsePeriod) => api.get<PulseBoard>('/v4/company-pulse', { period });
export const getPulseConfiguration = () => api.get<PulseConfiguration>('/v4/company-pulse/configuration');
export const savePulseConfiguration = (selection: Pick<PulseConfiguration, 'version' | 'kpiIds' | 'rockIds'>) =>
  api.put<{ version: number }>('/v4/company-pulse/configuration', selection);
